import React, { useContext, useState } from "react";
import { Badge, Button, Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { TipoAtendimentoContext } from "../../../contexts/TipoAtendimentoContext";
import { TagsContext } from "../../../contexts/TagsContext";
import "./index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { faCheckSquare, faSquare } from "@fortawesome/free-regular-svg-icons";
import stringHelper from "../../../helpers/StringHelper";
import Select from "react-select";

export function AdicionarMarcadoresConclusaoAtendimento({atendimento, closeModal, salvarAtendimento}){
  const {tiposAtendimento} = useContext(TipoAtendimentoContext);
  const [marcadoresSelecionados, setMarcadoresSelecionados] = useState(atendimento?.tags?.map((item) => {return {nome: item.nome, id_tag: item.id_tag}}) ?? [])
  const [textoPesquisa, setTextoPesquisa] = useState("");
  const {tagsLista} = useContext(TagsContext);

  const methods = useForm({defaultValues:{
    tipo_atendimento: {
      label: atendimento?.tipo_atendimento?.descricao, 
      value: atendimento?.tipo_atendimento?.id
    }
  }});

  const handleOnSubmit = (data)=>{
    data.tags = marcadoresSelecionados;
    data.tipo_atendimento = data?.tipo_atendimento?.value;
    salvarAtendimento(data);
    closeModal();
  }

  function montaOpcoes(recursos, descricao, valor) {
    return recursos.map(recurso => {
      return {
        label: recurso[descricao],
        value: recurso[valor]
      }
    })
  }

  return (
    <Form className="adicao-marcadores-section" onSubmit={methods.handleSubmit(handleOnSubmit)}>
      <Form.Group className="mb-0">
        <Form.Label>Tipo do Atendimento</Form.Label>
        <Controller
          name="tipo_atendimento"
          control={methods.control}
          render={({ field }) => (
            <Select
              {...field}
              placeholder="Tipo de Atendimento"
              name="tipo_atendimento"
              options={montaOpcoes(tiposAtendimento, 'descricao', 'id')}
              className="basic-multi-select"
              classNamePrefix="select"
              menuPosition="fixed"
          />)}
        />
      </Form.Group>
      {!!marcadoresSelecionados?.length && 
        <div className="marcadores-selecionados">
          <span>{marcadoresSelecionados?.length?.toString().padStart(2,'0')} marcador(es) selecionado(s)</span>
          <div className="marcadores-selecionados-section">
            {marcadoresSelecionados?.map((marcador, index)=>{
              return (
                <Badge variant="info" className="marcador-selecionado" key={index}>
                  <span>
                    {marcador.nome}
                  </span>
                  <div 
                    className="desmacar-section"
                    onClick={()=>{
                      setMarcadoresSelecionados((current) => current.filter((item) => item.id_tag !== marcador.id_tag))
                    }}
                  >
                    <FontAwesomeIcon icon={faTimes}/>
                  </div>
                </Badge>
              )
            })}
          </div>
        </div>
      }
      <fieldset className="marcadores-disponíveis-section">
        <legend>Lista de Marcadores:</legend>
        <Form.Group className="mb-0">
          <Form.Control
            type="text"
            placeholder="Pesquisar"
            onChange={(event) => {
              setTextoPesquisa(stringHelper.normalizar(event.target.value))
            }}
          >
          </Form.Control>
        </Form.Group>
        <div className="marcadores-section">
          {tagsLista.filter((tag)=> (!textoPesquisa.length || stringHelper.normalizar(tag.nome).includes(textoPesquisa))).map((tag, index)=>{
            const marcadorSelecionado = marcadoresSelecionados?.find((item) => item.id_tag === tag.id_tag);
            return (
              <Badge 
                variant="secondary" 
                className={`marcador ${marcadorSelecionado ? 'selecionado' : ''}`} 
                key={index}
                onClick={()=>{
                  if(marcadorSelecionado){
                    setMarcadoresSelecionados((current) => current.filter((item) => item.id_tag !== tag.id_tag))
                  }else{
                    setMarcadoresSelecionados((current) => [...current, {nome: tag.nome, id_tag: tag.id_tag}])
                  }
                }}
              >
                <FontAwesomeIcon icon={marcadorSelecionado ? faCheckSquare : faSquare }/>
                {tag.nome}
              </Badge>
            )
          })}
        </div>
      </fieldset>
      <Form.Group>
        <Form.Control
          as="textarea"
          rows={4}
          {...methods.register("observacao_finalizacao", { required: false })}
          placeholder="Informe um descrição sobre a conclusão do atendimento:"
        >
        </Form.Control>
      </Form.Group>
      <div className="footer-modal">
        <Button type="button" variant="secondary" onClick={()=>{closeModal()}}>Cancelar</Button>
        <Button 
          type="button" 
          variant="info" 
          onClick={()=>{
            handleOnSubmit(methods.getValues());
          }}
        >Salvar</Button>
        <Button 
          type="button" 
          variant="success" 
          onClick={()=>{
            let dados = methods.getValues();
            dados.finalizar = true;
            handleOnSubmit(dados);
          }}
        >Finalizar</Button>
      </div>
    </Form>
  )
}
